import { observer } from 'mobx-react';
import { createContext, Dispatch, SetStateAction, useContext, useState } from 'react';
import { Noop } from '../../extViewmodels/Utils';
import { useModal } from '../../models/hooks/useModal';
import { AidaAudioPlayer } from '../components/AudioPlayer';
import type { RecordingPlaybackSurface } from '../services/recordingPlayback';

export interface IAudioPlayerContext {
	audioSrc: string;
	setAudioSrc: Dispatch<SetStateAction<string>>;
	title: string;
	setTitle: Dispatch<SetStateAction<string>>;
	subtitle: string;
	setSubtitle: Dispatch<SetStateAction<string>>;
	phoneCallId: string;
	setPhoneCallId: Dispatch<SetStateAction<string>>;
	/** Which entry point opened the player, for the recording-playback report. */
	surface: RecordingPlaybackSurface;
	setSurface: Dispatch<SetStateAction<RecordingPlaybackSurface>>;
	setIsOpen: (newBool: boolean) => () => void;
}

export const AudioPlayerContext = createContext<IAudioPlayerContext>(null);

export const AudioPlayerProvider: React.FC<React.PropsWithChildren> = observer(({ children }) => {
	const [audioSrc, setAudioSrc] = useState('');
	const [title, setTitle] = useState('');
	const [subtitle, setSubtitle] = useState('');
	const [phoneCallId, setPhoneCallId] = useState(undefined);
	const [surface, setSurface] = useState<RecordingPlaybackSurface>(undefined);
	const audioModal = useModal(false, Noop, [], false, true);

	return (
		<AudioPlayerContext.Provider
			value={{
				audioSrc,

				phoneCallId,
				setAudioSrc,
				setIsOpen: audioModal.setIsOpen,

				setPhoneCallId,
				setSubtitle,
				setSurface,
				setTitle,
				subtitle,
				surface,
				title,
			}}
		>
			{children}
			<AidaAudioPlayer {...audioModal} />
		</AudioPlayerContext.Provider>
	);
});

export const useAudio = () => useContext<IAudioPlayerContext>(AudioPlayerContext);
